import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc, limit, startAfter } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseLogService {
  async getAllLogs() {
    const logsRef = collection(db, 'app_logs')
    const q = query(logsRef, orderBy('created_at', 'desc'))
    const snapshot = await getDocs(q)
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getLogsPaginated(pageSize = 40, lastDoc = null) {
    const logsRef = collection(db, 'app_logs')
    let q
    
    if (lastDoc) {
      q = query(logsRef, orderBy('created_at', 'desc'), startAfter(lastDoc), limit(pageSize))
    } else {
      q = query(logsRef, orderBy('created_at', 'desc'), limit(pageSize))
    }
    
    const snap = await getDocs(q)
    const logs = snap.docs.map(d => ({ id: d.id, ...d.data() }))
    const lastVisible = snap.docs[snap.docs.length - 1]
    
    return {
      logs,
      lastVisible,
      hasMore: snap.docs.length === pageSize
    }
  }

  async getLogById(id) {
    const ref = doc(db, 'app_logs', id)
    const snap = await getDoc(ref)
    if (snap.exists()) {
      return { id: snap.id, ...snap.data() }
    }
    return null
  }
}
